export default __webpack_public_path__ + "static/media/FireUp-removebg.8ad9df29.png";